import React from 'react';
import { inject } from 'mobx-react';

import { SectionLayout } from 'layouts/section';

const styles = require('./copyright-page.styles.scss');


@inject('analyticsStore')
export class CopyrightPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/copyright');
  }

  render() {
    return (
      <div className={styles.TermsPage}>
        <SectionLayout>
          <h1>Urheberecht / Copyright</h1>
          <p>
            Die auf dieser Homepage verwendeten Bilder, Texte, PFD's, Logos und Layouts unterliegen einem uneingeschränkten Copyright- und Urheberrechtsschutz der jeweiligen Quellen/ Inhaber. Eine Verwendung durch Dritte ist nicht gestattet.
          </p>
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/copyright/copyright.page.jsx